import { cn, linkToVideoEmbedURL } from "@/lib/utils";
import { TPostLink } from "@/types/post";
import Link from "next/link";

export const LinkCard = ({
	link,
	size,
	className,
}: {
	className?: string;
	link: TPostLink;
	// TODO (zeekhug): Better naming or demonstration for size variable
	size: "small" | "compact" | "free";
}) => {
	const embedUrl = linkToVideoEmbedURL(link.url);

	return embedUrl ? (
		<iframe
			width="560"
			height="315"
			allowFullScreen
			title={link.title}
			src={embedUrl}
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
			referrerPolicy="strict-origin-when-cross-origin"
			className={cn("m-auto aspect-video h-full w-auto", size === "small" && "h-24", className)}
		></iframe>
	) : (
		<Link
			href={link.url}
			target="_blank"
			className={cn(className, "w-fit overflow-clip rounded-md")}
		>
			<img
				src={link.image ?? "/images/link-placeholder.png"}
				alt={link.title}
				width={1080}
				height={1080}
				className={cn(
					"m-auto w-auto object-contain",
					size === "free" && "h-full",
					link.url && (size === "small" ? "m-auto h-24" : "h-64")
				)}
			/>

			{link.url && size !== "small" && (
				<div className="space-y-1 bg-slate-200 p-4">
					<p className="font-semibold">{link.title ?? ""}</p>
					<span className="line-clamp-1 text-sm text-gray-500">{link.description ?? ""}</span>
					<p className="block text-sm text-gray-500">{link.url}</p>
					{link.url}
				</div>
			)}
		</Link>
	);
};
